import { BaseUnits } from "uom";
import * as UnitTimes from "../unit-times";
import { Steradian } from "./solid-angle";
/**
 * The derived unit for luminous flux ( <code>lm</code> ).
 * One Lumen is equal to the amount of light given out through a solid angle by a source of one
 * candela intensity radiating equally in all directions.
 */
export var Lumen = UnitTimes.luminousIntensityBySolidAngle("Lumen", BaseUnits.Candela, Steradian);
//# sourceMappingURL=luminous-flux.js.map